import { Navigate } from "react-router-dom";
import { getCookieToken } from "../shared/helperFunction";

const PublicRoute = ({ children }) => {
    const token = getCookieToken("accessToken");
    return (!token ? children : <Navigate to="/dashboard" replace />)
};


export default PublicRoute;